<div
    class="agpr-chipsContainer"
    [ngClass]="{'agpr-chipsContainer-noPadding': ignorePadding}">
    @if (!value?.length && placeholder) {
        <span class="agpr-chips-placeholder">{{ placeholder | localize }}</span>
    } @else {
        <ul
            #chipList
            [id]="id"
            class="agpr-chips"
            agprListKeyboardNavigation
            listOrientation="horizontal"
            [focusOnChild]="true"
            [list]="value"
            [attr.aria-labelledby]="ariaLabelledBy"
            [ngClass]="{'agpr-chips--withClearAllButton': clearAllChipsButton && value.length > 0}"
        >
            <ng-container *ngFor="let chip of value; index as i">
                <li
                    class="agpr-chip"
                    [id]="id + '.chip_' + i"
                    [attr.aria-label]="(labelFieldName ? chip[labelFieldName] : chip) | localize"
                >
                    @if (!useLink) {
                        <span
                            class="agpr-chip-label"
                            [pTooltip]="style === agprComponentStyle.social ?
                                (labelFieldName ? chip[labelFieldName] : chip) : ''"
                            tooltipPosition="top"
                        >
                            {{ (labelFieldName ? chip[labelFieldName] : chip) | localize }}
                        </span>
                    } @else {
                        <a
                            class="agpr-chip-label"
                            [pTooltip]="style === agprComponentStyle.social ?
                                (labelFieldName ? chip[labelFieldName] : chip) : ''"
                            tooltipPosition="top"
                            target="_blank"
                            [href]="linkFieldName ? chip[linkFieldName] : chip"
                        >
                            {{ (labelFieldName ? chip[labelFieldName] : chip) | localize }}
                    </a>

                    }
                    <button
                        *ngIf="!disabled"
                        [id]="id + '_chip_' + i + '_delete'"
                        class="agpr-chip-icon agpr-i-close"
                        agprTooltip="Common.forms.chips.delete"
                        [useTooltipAsAriaLabel]="false"
                        tooltipPosition="top"
                        (click)="removeChip(chip)"
                        [attr.aria-label]="((labelFieldName ? chip[labelFieldName] : chip) | localize) + ' ' + ('Common.forms.chips.delete' | localize)"
                    ></button>
                </li>
            </ng-container>
        </ul>

    }
    <agpr-button
        *ngIf="clearAllChipsButton && value.length > 0"
        class="agpr-chips-clearAllIcon"
        icon="fa-kit-duotone fa-agpr-remove-all"
        [tooltip]="clearAllChipsTooltip"
        tooltipPosition="top"
        [style]="buttonTypes.icon"
        (click)="removeAllChips()"
    >
    </agpr-button>
</div>
